import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import { Link, useSearchParams } from 'react-router-dom';
import { deleteMAFAA030, getAdminLoginUser, postMAFAA080, putMAFAA080, postMAFAA030VisitedCount } from '../../../services/Api';
import momentDate from '../../../shared/components/MomentDate';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { DOMAIN_USER, MENU_ADVERTISES, MESSAGE } from '../../../shared/constants/app';
import { formatDate, handleFocus } from '../../../utils';

const MAFAA080 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const startDateBannerRef = useRef();
    const endDateBannerRef = useRef();
    const recruitFromBannerRef = useRef();
    const recruitEndBannerRef = useRef();
    const [dataStatistic, setDataStatistic] = useState([]);
    const [dataBanners, setDataBanners] = useState([]);
    const [dataComments, setDataComments] = useState([]);
    const [searchCondition, setSearchCondition] = useState('MemberID');
    const [keyword, setKeyword] = useState('');
    const [selectedMemberId, setSelectedMemberId] = useState(null);

    const [dateRate, setDateRate] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [selectedDates, setSelectedDates] = useState({});
    const [isEnds, setIsEnds] = useState({});
    const [dataSave, setDataSave] = useState({
        seq: null,
        rSeq: null,
        goodCode: '',
        bstartDate: '',
        bendDate: '',
        rstartDate: '',
        rendDate: '',
        isEnd: 'N',
        comments: '',
        bmemberID: null,
    });

    const getSearchCondition = (e) => {
        const selectedValue = e.target.value;
        setSearchCondition(selectedValue);
    };
    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.getAttribute('value-date-range');
        setDateRate(valueRangeDate);
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name, memberID = '') => {
        setDateRate('');
        if (
            name === 'startDateBanner' ||
            name === 'endDateBanner' ||
            name === 'recruitFromBanner' ||
            name === 'recruitEndBanner'
        ) {
            setSelectedDates((prev) => ({
                ...prev,
                [memberID]: {
                    ...prev[memberID],
                    [name]: date,
                },
            }));
            setDataSave((prev) => ({ ...prev, [name]: moment(date).format('YYYY-MM-DD') }));
        } else if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    const handleChange = (e, memberID) => {
        const { name, value } = e.target;
        if (name === 'isEnd') {
            setIsEnds((prev) => ({
                ...prev,
                [memberID]: {
                    ...prev[memberID],
                    [name]: value,
                },
            }));
        }

        setDataSave((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSave = ({ bannerSeq, recruitSeq, bmemberID }) => {
        const bannerData = dataBanners.find((banner) => banner.seq === bannerSeq) || {};
        const payload = {
            seq: bannerSeq,
            rSeq: recruitSeq,
            bStartDate:
                moment(dataSave.startDateBanner).format('YYYY-MM-DD') ||
                moment(bannerData.startDate).format('YYYY-MM-DD'),
            bEndDate:
                moment(dataSave.endDateBanner).format('YYYY-MM-DD') || moment(bannerData.endDate).format('YYYY-MM-DD'),
            rStartDate:
                moment(dataSave.recruitFromBanner).format('YYYY-MM-DD') ||
                moment(bannerData.recruitFrom).format('YYYY-MM-DD'),
            rEndDate:
                moment(dataSave.recruitEndBanner).format('YYYY-MM-DD') ||
                moment(bannerData.recruitEnd).format('YYYY-MM-DD'),
            isEnd: dataSave.isEnd || bannerData.isEnd,
            comments: dataSave.comment || bannerData.comment,
            bMemberID: bmemberID,
        };
        if (!payload.comment || payload.comment === '') {
            window.alert('코멘트를 입력해 주세요.');
            handleFocus('comment');
            return;
        }
        const isConfirm = window.confirm(MESSAGE.confirm.update);

        if (isConfirm) {
            putMAFAA080(payload)
                .then(() => {
                    window.alert(MESSAGE.notify.updateSuccess);
                    getListData();
                })
                .catch((error) => {
                    console.log(error);
                    window.alert(MESSAGE.notify.updateError);
                });
        }
    };

    const handleDelete = (id) => {
        const isConfirm = window.confirm(MESSAGE.confirm.delete);
        if (isConfirm) {
            deleteMAFAA030(id)
                .then(() => {
                    window.alert(MESSAGE.notify.deleteSuccess);
                    getListData();
                })
                .catch((error) => console.log(error));
        }
    };

    const getListData = async (currentPage = page) => {
        const startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD') : null;

        try {
            const { data } = await postMAFAA080({
                page: currentPage,
                searchCondition,
                keyword: keyword?.trim(),
                size: 40,
                startDate: startDateFormated,
                endDate: endDateFormated,
            });

            let banners = data.list.data || [];
            setDataStatistic(data.statistic);

            // 2. get visited count
            if (banners.length > 0) {
                const bannerSeqList = banners.map((b) => b.seq);
                const response = await postMAFAA030VisitedCount(bannerSeqList);
                const visitedResp = response.data;

                // merge to banner
                banners = banners.map((b) => {
                    const visitedArr = visitedResp[b.seq];
                    const visitedData = visitedArr && visitedArr.length > 0 ? visitedArr[0] : {};
                    return {
                        ...b,
                        visitedFromBanner: visitedData.visitedFromBanner ?? b.visitedFromBanner,
                        visitedFromListRecruit: visitedData.visitedFromListRecruit ?? b.visitedFromListRecruit,
                    };
                });
            }
            setDataBanners(data.list.data);
            const comments = banners.reduce((acc, banner) => {
                const memberID = banner.memberID;
                if (data.comments[memberID]) {
                    acc[memberID] = data.comments[memberID];
                }
                return acc;
            }, {});
            setDataComments(comments);
            setPages(data.list.info);
        } catch (error) {
            console.error(error);
        }
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            setSearchParams({ page: 1 });
            getListData(1);
        }
    };

    const clickReset = () => {
        setSearchParams('');
        setSearchCondition('MemberID');
        setKeyword('');
        setDateRate('');
        setStartDate('');
        setEndDate('');
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);

    const handleShowComment = (memberID) => {
        setDataSave({});
        setSelectedMemberId(selectedMemberId === memberID ? null : memberID);
    };
    const handleOpenUser = async (e, memberID) => {
        e.preventDefault();
        const adminResponse = await getAdminLoginUser({ params: { memberID } });
        const url = DOMAIN_USER + '/auth-redirect?token=' + adminResponse.data;
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_ADVERTISES} />
                <div className="content-right business-banner">
                    <div className="title">고정 옵션</div>

                    <div id="search-box">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th>조건 검색</th>
                                    <td>
                                        <div className="select-box">
                                            <select onChange={getSearchCondition} value={searchCondition}>
                                                <option value="MemberID">회원 ID</option>
                                                <option value="NameKor">이름</option>
                                                <option value="BizCompany">치과명</option>
                                            </select>
                                            <input
                                                type="text"
                                                className="input-table"
                                                placeholder="검색어 입력"
                                                value={keyword}
                                                onChange={inputChange}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>검색어 입력</th>
                                    <td colSpan={3}>
                                        <div className="flex group-item">
                                            <div className="group-datepicker">
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={startDateRef}
                                                        onChange={(date) => handleDateChange(date, 'startDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={startDate}
                                                        maxDate={endDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => startDateRef.current.setFocus()}
                                                    />
                                                </div>
                                                <span>~</span>
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={endDateRef}
                                                        onChange={(date) => handleDateChange(date, 'endDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={endDate}
                                                        minDate={startDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="end-date-icon"
                                                        onClick={() => endDateRef.current.setFocus()}
                                                    />
                                                </div>
                                            </div>
                                            <ul className="select-value">
                                                <li
                                                    value-date-range="today"
                                                    className={dateRate === 'today' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    오늘
                                                </li>
                                                <li
                                                    value-date-range="1week"
                                                    className={dateRate === '1week' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    일주일
                                                </li>
                                                <li
                                                    value-date-range="15days"
                                                    className={dateRate === '15days' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    15일
                                                </li>
                                                <li
                                                    value-date-range="1month"
                                                    className={dateRate === '1month' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    1개월
                                                </li>
                                                <li
                                                    value-date-range="3months"
                                                    className={dateRate === '3months' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    3개월
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="group-button center">
                            <button className="btn btn-gray-bold" onClick={clickSearch}>
                                검색
                            </button>
                            <button className="btn btn-gray-thin" onClick={clickReset}>
                                초기화
                            </button>
                        </div>
                    </div>
                    <div className="results">
                        <div className="group-table-results">
                            <div className="table-left">
                                <table className="table-gray">
                                    <thead>
                                        <tr>
                                            <th>금일신청</th>
                                            <th>금일서비스</th>
                                            <th>금일종료</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{dataStatistic.bannerRegisteredToday}</td>
                                            <td>{dataStatistic.bannerRunningToday}</td>
                                            <td>{dataStatistic.bannerExpiringToday}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="table-right">
                                <table className="table-gray">
                                    <thead>
                                        <tr>
                                            <th>등록미확인</th>
                                            <th>등록확인</th>
                                            <th>게재중</th>
                                            <th>게재예정</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{dataStatistic.bannerApproved}</td>
                                            <td>{dataStatistic.bannerPendingOrRejected}</td>
                                            <td>{dataStatistic.bannerCurrentlyActive}</td>
                                            <td>{dataStatistic.bannerScheduled}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="table-details">
                            <table className="table-gray">
                                <thead>
                                    <tr>
                                        <th />
                                        <th style={{ width: '6%' }}>
                                            회원ID
                                            <br />
                                            (이름)
                                        </th>
                                        <th>치과명</th>
                                        {/* <th>배너상태</th> */}
                                        <th style={{ width: '20%' }}>
                                            채용공고
                                            <br />
                                            조회수
                                        </th>
                                        <th style={{ width: '5%' }}>신청일</th>
                                        <th style={{ width: '5%' }}>결제일</th>
                                        <th>광고상품</th>
                                        <th>
                                            서비스기간
                                            <br />
                                            (채용기간)
                                        </th>
                                        <th style={{ width: '6%' }}>남은일수</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dataBanners && dataBanners?.length > 0 ? (
                                        dataBanners.map((item, index) => {
                                            return (
                                                <React.Fragment key={'banner' + index}>
                                                    <tr>
                                                        <td>{item.seq}</td>
                                                        <td className="dataBanners_nameKor">
                                                            <button
                                                                onClick={() => handleShowComment(item?.seq)}
                                                                className="dataBanners_nameKor"
                                                            >
                                                                {item.memberID}
                                                                <br />({item.nameKor})
                                                            </button>
                                                            <Link
                                                                onClick={(e) => handleOpenUser(e, item?.memberId)}
                                                                style={{ paddingRight: '15px' }}
                                                            >
                                                                덴탈잡로그인
                                                            </Link>
                                                            <div>
                                                                <i
                                                                    onClick={() => handleShowComment(item?.seq)}
                                                                    className={`icon icon-arrow-right icon-arrow-style ${selectedMemberId === item?.seq
                                                                        ? 'blue active'
                                                                        : ''
                                                                        }`}
                                                                ></i>
                                                            </div>
                                                        </td>
                                                        <td>{item.bizCompany}</td>
                                                        {/* <td>{item.ipGumCheck}</td> */}
                                                        <td>
                                                            {item.title}
                                                            <br />
                                                            (채용광고 조회: {item.visitedFromListRecruit || 0} /
                                                            배너광고 조회: {item.visitedFromBanner || 0})
                                                        </td>
                                                        <td>
                                                            {moment(item.addDate).format('YYYY.MM.DD')} <br />{' '}
                                                            {moment(item.addDate).format('a hh:mm:ss')}
                                                        </td>
                                                        <td>
                                                            {moment(item.ipGumCheckDate).format('YYYY.MM.DD')} <br />{' '}
                                                            {moment(item.ipGumCheckDate).format('a hh:mm:ss')}
                                                        </td>
                                                        <td>{item.goodName}</td>
                                                        <td>
                                                            {formatDate(item.startDate)} ~ {formatDate(item.endDate)}
                                                            <br />({formatDate(item.recruitFrom)} ~{' '}
                                                            {formatDate(item.recruitEnd)})
                                                        </td>
                                                        <td>
                                                            {item.remainDays < 0 ? null : item.remainDays === 0 ? (
                                                                <span style={{ color: '#FF0000' }}>
                                                                    {item.remainDays}
                                                                </span>
                                                            ) : item.remainDays <= 3 ? (
                                                                <span style={{ color: '#FF0000' }}>
                                                                    {item.remainDays}
                                                                </span>
                                                            ) : (
                                                                <span style={{ color: '#0000FF' }}>
                                                                    {item.remainDays}
                                                                </span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                    {selectedMemberId === item.seq && (
                                                        <tr className="show-comment">
                                                            <td colSpan={10}>
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>상품명</td>
                                                                            <td>옵션시작일</td>
                                                                            <td>
                                                                                <div className="datepicker-child">
                                                                                    <DatePicker
                                                                                        ref={startDateBannerRef}
                                                                                        onChange={(date) =>
                                                                                            handleDateChange(
                                                                                                date,
                                                                                                'startDateBanner',
                                                                                                item.memberID,
                                                                                            )
                                                                                        }
                                                                                        locale={'ko'}
                                                                                        placeholderText={'YYYY/MM/DD'}
                                                                                        dateFormat={'yyyy/MM/dd'}
                                                                                        selected={
                                                                                            selectedDates[item.memberID]
                                                                                                ?.startDateBanner ||
                                                                                            item.startDate
                                                                                        }
                                                                                        maxDate={
                                                                                            selectedDates[item.memberID]
                                                                                                ?.endDateBanner ||
                                                                                            item.endDate ||
                                                                                            null
                                                                                        }
                                                                                    />
                                                                                    <i
                                                                                        className="icon icon-date"
                                                                                        id="start-date-icon"
                                                                                        onClick={() =>
                                                                                            startDateBannerRef.current.setFocus()
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td>채용시작일</td>
                                                                            <td>
                                                                                <div className="datepicker-child">
                                                                                    <DatePicker
                                                                                        ref={recruitFromBannerRef}
                                                                                        onChange={(date) =>
                                                                                            handleDateChange(
                                                                                                date,
                                                                                                'recruitFromBanner',
                                                                                                item.memberID,
                                                                                            )
                                                                                        }
                                                                                        locale={'ko'}
                                                                                        placeholderText={'YYYY/MM/DD'}
                                                                                        dateFormat={'yyyy/MM/dd'}
                                                                                        selected={
                                                                                            selectedDates[item.memberID]
                                                                                                ?.recruitFromBanner ||
                                                                                            item.recruitFrom
                                                                                        }
                                                                                        maxDate={
                                                                                            selectedDates[item.memberID]
                                                                                                ?.recruitEndBanner ||
                                                                                            item.recruitEnd ||
                                                                                            null
                                                                                        }
                                                                                    />
                                                                                    <i
                                                                                        className="icon icon-date"
                                                                                        id="recruit-from-date-icon"
                                                                                        onClick={() =>
                                                                                            recruitFromBannerRef.current.setFocus()
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td>옵션상태</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>덴탈잡그랜드배너(채용광고포함)</td>
                                                                            <td>옵션종료일</td>
                                                                            <td>
                                                                                <div className="datepicker-child">
                                                                                    <DatePicker
                                                                                        ref={endDateBannerRef}
                                                                                        onChange={(date) =>
                                                                                            handleDateChange(
                                                                                                date,
                                                                                                'endDateBanner',
                                                                                                item.memberID,
                                                                                            )
                                                                                        }
                                                                                        locale={'ko'}
                                                                                        placeholderText={'YYYY/MM/DD'}
                                                                                        dateFormat={'yyyy/MM/dd'}
                                                                                        selected={
                                                                                            selectedDates[item.memberID]
                                                                                                ?.endDateBanner ||
                                                                                            item.endDate
                                                                                        }
                                                                                        minDate={
                                                                                            selectedDates[item.memberID]
                                                                                                ?.startDateBanner ||
                                                                                            item.startDate ||
                                                                                            null
                                                                                        }
                                                                                    />
                                                                                    <i
                                                                                        className="icon icon-date"
                                                                                        id="end-date-icon"
                                                                                        onClick={() =>
                                                                                            endDateBannerRef.current.setFocus()
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td>채용종료밀</td>
                                                                            <td>
                                                                                <div className="datepicker-child">
                                                                                    <DatePicker
                                                                                        ref={recruitEndBannerRef}
                                                                                        onChange={(date) =>
                                                                                            handleDateChange(
                                                                                                date,
                                                                                                'recruitEndBanner',
                                                                                                item.memberID,
                                                                                            )
                                                                                        }
                                                                                        locale={'ko'}
                                                                                        placeholderText={'YYYY/MM/DD'}
                                                                                        dateFormat={'yyyy/MM/dd'}
                                                                                        selected={
                                                                                            selectedDates[item.memberID]
                                                                                                ?.recruitEndBanner ||
                                                                                            item.recruitEnd
                                                                                        }
                                                                                        minDate={
                                                                                            selectedDates[item.memberID]
                                                                                                ?.recruitFromBanner ||
                                                                                            item.recruitFrom ||
                                                                                            null
                                                                                        }
                                                                                    />
                                                                                    <i
                                                                                        className="icon icon-date"
                                                                                        id="recuit-end-date-icon"
                                                                                        onClick={() =>
                                                                                            recruitEndBannerRef.current.setFocus()
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="select-box">
                                                                                    <select
                                                                                        value={
                                                                                            isEnds[item.memberID]
                                                                                                ?.isEnd !== undefined
                                                                                                ? isEnds[item.memberID]
                                                                                                    ?.isEnd
                                                                                                : item.isEnd
                                                                                        }
                                                                                        onChange={(e) =>
                                                                                            handleChange(
                                                                                                e,
                                                                                                item.memberID,
                                                                                            )
                                                                                        }
                                                                                        name="isEnd"
                                                                                    >
                                                                                        <option value="N">등록</option>
                                                                                        <option value="Y">마감</option>
                                                                                    </select>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Comment</td>
                                                                            <td colSpan={5}>
                                                                                <textarea
                                                                                    name="comment"
                                                                                    onChange={handleChange}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <div className="note-table">
                                                                    *Comment 등록형식: [상품명] / [Comment] ex
                                                                    프리미엄배너/전화가 안와요 불만
                                                                    <br />
                                                                    *반드시 배너 종료일이 채용 종료일보다 작거나 같도록
                                                                    확인하고 설정해 주세요.
                                                                    <div className="d-flex gap-2 justify-content-center mt-2">
                                                                        <button
                                                                            className="btn btn-primary"
                                                                            onClick={() =>
                                                                                handleSave({
                                                                                    bannerSeq: item.seq,
                                                                                    recruitSeq: item.recSeq,
                                                                                    bmemberID: item.memberID,
                                                                                })
                                                                            }
                                                                        >
                                                                            등록 / 수정
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-danger"
                                                                            onClick={() => handleDelete(item.seq)}
                                                                        >
                                                                            삭제
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="table-comment-results"
                                                                    style={{ overflow: 'scroll', maxHeight: '400px' }}
                                                                >
                                                                    <div className="table-comment-results-title">
                                                                        등록된 Comment (
                                                                        {dataComments[item.memberID] &&
                                                                            dataComments[item.memberID]?.length}
                                                                        )
                                                                    </div>
                                                                    <table className="table-gray table-comments">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Seq</th>
                                                                                <th>등록일</th>
                                                                                <th>관리자명</th>
                                                                                <th>사이트</th>
                                                                                <th>Comment</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {dataComments[item.memberID] &&
                                                                                dataComments[item.memberID]?.length > 0 ? (
                                                                                dataComments[item.memberID].map(
                                                                                    (comment, index) => (
                                                                                        <tr
                                                                                            key={
                                                                                                'comments' +
                                                                                                item.memberID +
                                                                                                index
                                                                                            }
                                                                                        >
                                                                                            <td>{comment.seq}</td>
                                                                                            <td>
                                                                                                {formatDate(
                                                                                                    comment.addDate,
                                                                                                )}
                                                                                            </td>
                                                                                            <td>{comment.adminName}</td>
                                                                                            <td>{comment.sitePost}</td>
                                                                                            <td>{comment.comments}</td>
                                                                                        </tr>
                                                                                    ),
                                                                                )
                                                                            ) : (
                                                                                <tr key={'no-data-' + item.memberID}>
                                                                                    <td colSpan={5}>
                                                                                        <span className="no-data">
                                                                                            데이타가 없습니다.
                                                                                        </span>
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={11}>데이타가 없습니다.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <Pagination pages={pages} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAFAA080;
